import { Page, Section } from '../ui/kit';
import { LinkedinAccount, LinkedinTasks } from '../ui/linkedin';

// LinkedIn tasks: the connection notes and messages Outlevo drafted for the signed-in person to send from their own
// LinkedIn, over every campaign with LinkedIn touches on (src/outbound/linkedin.ts), and their own LinkedIn account for
// sending automatically (src/outbound/linkedin-auto.ts). Home's Today and the daily brief link here.
export function LinkedinPage() {
  return (
    <Page title="LinkedIn tasks">
      <Section title="Your LinkedIn account"><LinkedinAccount /></Section>
      <LinkedinTasks />
    </Page>
  );
}
